import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';

// Importar imágenes
import background1 from '../assets/background.webp';
import background2 from '../assets/background2.webp';
import background3 from '../assets/background3.webp';
import background4 from '../assets/background4.webp';
import background5 from '../assets/background5.webp';

const Hero = () => {
    const { t } = useTranslation();
    const [currentImage, setCurrentImage] = useState(0);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    
    const backgroundImages = [
        background1,
        background2,
        background3,
        background4,
        background5
    ];

    // Precarga de imágenes optimizada
    useEffect(() => {
        let loadedCount = 0;
        const totalImages = backgroundImages.length;

        const preloadImage = (src) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    loadedCount++;
                    if (loadedCount === totalImages) {
                        setImagesLoaded(true);
                    }
                    resolve();
                };
                img.onerror = reject;
                img.src = src;
            });
        };

        // Precargar todas las imágenes en paralelo
        Promise.all(backgroundImages.map(preloadImage))
            .catch(error => console.error('Error precargando imágenes:', error));
    }, []);

    // Cambio de imágenes optimizado
    const changeImage = useCallback(() => {
        setCurrentImage((prevImage) => (prevImage + 1) % backgroundImages.length);
    }, [backgroundImages.length]);

    useEffect(() => {
        if (!imagesLoaded) return;

        const interval = setInterval(changeImage, 5000);
        return () => clearInterval(interval);
    }, [imagesLoaded, changeImage]);

    return (
        <section id="inicio" className="hero">
            <div className="parallax-bg">
                <div className="carousel-container">
                    {backgroundImages.map((image, index) => (
                        <div
                            key={index}
                            className={`carousel-slide ${index === currentImage ? 'active' : ''}`}
                            style={{ 
                                backgroundImage: `url(${image})`,
                                opacity: imagesLoaded ? undefined : 0
                            }}
                        ></div>
                    ))}
                </div>
                <div className="parallax-layer-2"></div>
            </div>
            <div className="hero-content">
                <h1>
                    <span className="main-title">FEDERACIÓN</span>
                    <span className="title-line"></span>
                    <span className="sub-title">CORVUS NOCTA</span>
                </h1>
                <p className="slogan">{t('hero.slogan')}</p>
                <a href="#unete" className="join-button">
                    {t('hero.joinButton')}
                </a>
            </div>
        </section>
    );
};

export default Hero; 